import { SET_DIALOG_FLAG } from './actions';

const initialState = {
    open: false,
    subOpen: false,
    subConfirmOpen: false,
    updateCompOpen: false,
    deleteCompOpen: false,
    updateAttrOpen: false,
    deleteAttrOpen: false,
    attrOpen: false,
    bimOpen: false,
};

export function dialogsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_DIALOG_FLAG:
            return { ...state, [action.key]: action.value };
        default:
            return state;
    }
}
